
// TODO
// put this into config.js

const card_config = [
  {
    title: "Submit Data",
    description: "Create new datasets and upload files",
    href: "#/submission",
  },
  {
    title: "Manage your data",
    description: " Browse and Manage your data across data owner and groups",
    href: "#/datasets",
  },
];

//If you replace the title then StartCard.js will fail
const submission_cards_config = [
  {
    title: "Create new Project",
    description:
      "Create one or more projects to be added to the 3TR data warehouse",
    href: "#/submitprojects",
  },
  {
    title: "Create new Dataset",
    description:
      "Create one or more dataset to be added to the 3TR data warehouse",
    href: "#/createdatasets/selectproject",
  },
  {
    title: "Submit Files",
    description:
      "Submit files of a new or an existing dataset. This is the final data submission step ",
    href: "#/uploadfiles/selectproject",
  },
];

export default card_config;
export { submission_cards_config };
